interface LoginHospitalOption {
  _id?: string;
  userRole?: string;
}

/**
 * A single-clinic Sonographer entry may also represent the same person's Admin account.
 * Leaving hospitalId unset lets the existing authentication flow select Sonographer first.
 */
export const shouldUseSonographerFirstLogin = (
  hospitals: LoginHospitalOption[],
  selectedHospitalId?: string
): boolean => {
  if (!Array.isArray(hospitals) || hospitals.length !== 1) {
    return false;
  }

  const hospital = hospitals[0];
  const isSelectedClinic = !selectedHospitalId || hospital?._id === selectedHospitalId;
  const isSonographer = hospital?.userRole?.trim().toLowerCase() === 'sonographer';

  return isSelectedClinic && isSonographer;
};
